import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { gsap } from 'gsap';

export function initWhyChoose() {
  const parent = document.querySelector('.why-choose');
  if (!parent) return;

  const paginationEl = parent.querySelector('.swiper-pagination');
  new Swiper('.why-choose__swiper', {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 25,
    pagination: {
      el: paginationEl,
      clickable: true,
    },
  });

  const cards = parent.querySelectorAll('.why-choose__card');
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });

    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}
